/* istanbul ignore file */ /* this file is not used or will be deleted in other branches */
export const ucWords = (string: string): string => {
  return string ? string.replace(/^(.)|\s+(.)/g, ($1) => $1.toUpperCase()) : string;
};

export default ucWords;
